import React from 'react'
// components
import ScheduledField from 'components/PageComponents/Risks/Edit/components/ScheduledField'
import { ReduxDatePicker, ReduxDateTimePicker, ReduxTimePicker } from 'components/FormElements'
// types
import { IField } from 'types/graphql'
import { Validators } from 'utils/validators'
// constants
import { DATE_FORMAT_VALUES } from 'constants/objects'
// context
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'
import { RiskViewContext } from 'containers/Risks/RiskView/Risk/layers'

interface Props {
  form: string
  field: IField & { fieldLinkId?: string }
  validate: Validators
  disabled?: boolean
  required?: boolean
}

const ReduxPicker: React.FC<Props> = ({ form, field, validate, disabled, required }) => {
  const { risk } = React.useContext(RiskAPIContext)
  const { isScheduled } = React.useContext(RiskViewContext)

  const format = field.settings?.format || DATE_FORMAT_VALUES.DATE
  const dateFormat = field.settings?.dateFormat

  const pickerProps = {
    disabled,
    validate,
    required,
    dateFormat,
    name: field.name,
    label: field.label
  }

  if ((isScheduled || !!risk?.recurrence) && !field.fieldLinkId) {
    return <ScheduledField field={field.name} label={field.label} form={form} disabled={disabled} />
  }

  return (
    <>
      {format === DATE_FORMAT_VALUES.DATE && <ReduxDatePicker {...pickerProps} />}
      {format === DATE_FORMAT_VALUES.TIME && <ReduxTimePicker {...pickerProps} />}
      {format === DATE_FORMAT_VALUES.DATE_TIME && <ReduxDateTimePicker {...pickerProps} />}
    </>
  )
}

export default ReduxPicker
